module.exports = __webpack_public_path__ + "img/IMG_20191125_201205.a1b480f2.jpg";